module.exports = __webpack_public_path__ + "img/preview-2.f39e56aa.webp";